import {OrderStatus} from 'Common/constants/OrderStatus';
import {statusOrdering} from './constants';

export function convertCompletedStatuses(statuses: OrderStatus | OrderStatus[]) {
  const statusesArr = Array.isArray(statuses) ? statuses : [statuses];
  return statusesArr.map((s) => statusOrdering[s]);
}
